import React, { Fragment } from 'react';
import { Navbar, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {Link} from 'react-router-dom';
import {paths} from './MyRoutes';

export default function MyNavbar(){
    return (
        <Fragment>

<Navbar bg="dark" variant="dark" sticky="top" style={{opacity:"0.9"}}>
    <Link to={paths.home} className="navbar-brand mx-4 my-1">Mohammed Al-ameen</Link>
    <Nav className="mr-auto">
    <Link to={paths.home} className="nav-link active">Home</Link>
        <Link to={paths.blogsMenu} className="nav-link active">Blogs</Link>
    </Nav>
  </Navbar>
        </Fragment>
    );
}